import axios from "axios";
import useStore from "../store/store";

const instance = axios.create({
  /* eslint-disable-next-line */
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 500000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  const user = useStore.getState().user;

  config.headers = {
    ...config.headers,
    Authorization: user?.token ? `Bearer ${user.token}` : null,
  };

  // If it's multipart form data, let the browser set the Content-Type
  // This is important for file uploads
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }

  return config;
});

const responseBody = (response) => response.data;

const requests = {
  get: (url, body, headers) =>
    instance.get(url, body, headers).then(responseBody),

  post: (url, body, config = {}) =>
    instance.post(url, body, config).then(responseBody),

  put: (url, body, config = {}) =>
    instance.put(url, body, config).then(responseBody),

  patch: (url, body) => instance.patch(url, body).then(responseBody),

  delete: (url) => instance.delete(url).then(responseBody),
};

export default requests;
